import React from "react";
import { connect } from "react-redux";
import { fetchShippingInQueueData } from "../../utils/queries/request/shipping-queue";
import toastMessage from "../../utils/toastMessage";
import language from "../../language";
import { Table } from "../Table";
import { getStorage } from "../../utils/storage";
import axios from "axios";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

class ShipmentInformation extends React.Component {
  state = {
    page: 1,
    limit: 10,
    data: [],
    user: {},
  };

  componentDidMount() {
    this.loadUser();
    if (this.props.inventory) {
      this.getData(true);
    }
  }

  loadUser = async () => {
    const user = await getStorage();
    this.setState({ user });
  };

  handleCancelShipment = async (item) => {
    if (item.status !== "pending") {
      return toastMessage("error", `Cannot cancel a shipment with status: ${item.status}`);
    }
    const user = await getStorage();
    try {
      await axios({
        method: "PUT",
        url: `${API_URL}/shipping-queue`,
        data: { id: item._id, status: "cancelled" },
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user.token,
        },
      });
      toastMessage("success", `Shipment ${item.shipmentNumber} cancelled`);
      this.getData(true);
    } catch (error) {
      toastMessage("error", error);
    }
  };

  getData = async (isLoading) => {
    try {
      const { page, limit } = this.state;
      const { defaultLanguage, inventory } = this.props;

      if (!inventory || inventory === "") return;

      this.setState({ isLoading });

      const requestBody = {
        page,
        limit,
        inventory,
      };

      const { data, count, totalRecords } = await fetchShippingInQueueData(
        defaultLanguage,
        requestBody
      );

      this.setState({
        data: data,
        totalPageCount: count,
        totalRecords,
        isLoading: false,
      });
    } catch (error) {
      this.setState({
        isLoading: false,
      });

      toastMessage("error", error);
    }
  };

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].shipment_number,
        key: "shipmentNumber",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].from,
        key: "from.name",
      },
      {
        title: language[this.props.defaultLanguage].to,
        key: "to.name",
        render: (item) => item?.service?.name || item?.to?.name || "-",
      },
      {
        title: language[this.props.defaultLanguage].shipped_by,
        key: "addedBy.pin",
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].status,
        type: "status",
        key: "status",
      },
      {
        title: language[this.props.defaultLanguage].created_at,
        key: "createdAt",
        isMoment: true,
        formatTime: "lll",
      },
    ];

    return headers;
  }

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.getData(true);
      }
    );
  }
  render() {
    const isAdmin = this.state.user?.role === "superAdmin";
    return (
      <div className="card-body">
        <Table
          data={this.state.data}
          page={this.state.page}
          limit={this.state.limit}
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
          actions={[
            isAdmin && {
              canAccess: true,
              name: "Cancel",
              onPress: (item) => this.handleCancelShipment(item),
            },
          ].filter(Boolean)}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(ShipmentInformation);
